import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=1dd517be&"
import script from "./Frontend.vue?vue&type=script&lang=js&"
export * from "./Frontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports